import PropTypes from 'prop-types'
import React from 'react'

import footerLayoutConfig from '../../../config/layout/footer'
import FooterMarketplaceStats from './marketplaceStats'
import assetsPath from '../../../common/utils/assetsPath'

class SiteFooter extends React.Component {
  static propTypes = {
    stats: PropTypes.object
  }

  render () {
    const { stats } = this.props
    const { infoLinks, companyLinks, socialMediaLinks } = footerLayoutConfig

    return (
      <footer className='global-footer'>
        <div className='grid-container -layout-wide'>
          <div className='global-footer__container'>
            <nav className='global-footer-info-links'>
              <hr className='global-footer__separator fds-u-hide-large-and-above fds-u-mb4' />

              <ul className='global-footer-info-links__list'>
                {
                  infoLinks.map((column) => {
                    return (
                      <li key={column.key}
                        className='global-footer-info-links__list-item'>
                        <ul className='global-footer-sublist'>
                          <li className='global-footer-sublist__item-title'>
                            {column.titleHtml}
                          </li>
                          {
                            column.entries.map((entry) => {
                              return (
                                <li key={entry.key}
                                  className='global-footer-sublist__item h-p0'>
                                  <a className='global-footer__text-link'
                                    href={entry.url}>
                                    {entry.label}
                                  </a>
                                </li>
                              )
                            })
                          }
                        </ul>
                      </li>
                    )
                  })
                }
              </ul>
            </nav>

            <div className='global-footer-stats'>
              <img className='global-footer-stats__logo'
                alt='Envato Market'
                src={`${assetsPath()}/images/logo-envato-market.svg`} />

              <FooterMarketplaceStats stats={stats} />
            </div>
          </div>

          <hr className='global-footer__separator' />
          <div className='global-footer__container'>
            <div className='global-footer-company-links'>
              <ul className='global-footer-company-links__list'>
                {
                  companyLinks.map((entry) => {
                    return (
                      <li key={entry.key}
                        className='global-footer-company-links__list-item'>
                        <a className='global-footer__text-link -opacity-full'
                          href={entry.url}>
                          {entry.label}
                        </a>
                      </li>
                    )
                  })
                }
              </ul>

              <hr className='global-footer__separator fds-u-hide-small-and-above fds-u-mt3' />

              <small className='global-footer-company-links__copyright'>
                © 2017 Envato Pty Ltd. Trademarks and brands are the property of their respective owners.
              </small>
            </div>

            <div className='global-footer-social'>
              <link itemProp='sameAs' href='https://instagram.com/envato' />

              <ul itemScope itemType='http://schema.org/Organization'>
                {
                  socialMediaLinks.map((entry) => {
                    const iconSrc = assetsPath() + entry.icon
                    return (
                      <li key={entry.key}
                        className='global-footer-social__list-item'>
                        <a className='global-footer__icon-link'
                          itemProp='sameAs' rel='nofollow' href={entry.url}>
                          <img className='global-footer-social__icon'
                            alt={entry.label} title={entry.label} src={iconSrc} />
                        </a>
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default SiteFooter



// WEBPACK FOOTER //
// ./client/components/footer/siteFooter.js